import { FC } from 'react';
import { useRouter } from 'next/router';
import { RouteEnum } from 'pro/config/routers';
import Link from '@base/lib/Link';
import site from 'pro/config/site';
import { SiteLogo, ISiteLogoProps } from '@pro/common/SiteLogo';

export type IHeaderLogoProps = ISiteLogoProps;

export const HeaderLogo: FC<IHeaderLogoProps> = props => {
    const { pathname } = useRouter();
    const { className, ...rest } = props;

    return pathname === RouteEnum.HOME
        ? (
            <Link
                href={RouteEnum.HOME}
                className={className}
            >
                <h1 className={'visually-hidden'}>{site.brand}</h1>
                <SiteLogo
                    {...rest}
                    href={false}
                />
            </Link>
        )
        : <SiteLogo {...props}/>
};
